import { createRouter, createWebHashHistory } from 'vue-router';

import { setupGuard } from './guard';

// import.meta.glob() 直接引入所有的模块 Vite 独有的功能
const modulesFiles = import.meta.glob('./modules/*.js', {
  eager: true
});

let routeModules = [];

Object.keys(modulesFiles).forEach((key) => {
  const mod = modulesFiles[key].default || {};
  routeModules = routeModules.concat(mod);
});

const constantRoutes = [
  {
    path: '/',
    redirect: '/index'
  },
  ...routeModules
];
const router = createRouter({
  history: createWebHashHistory(),
  routes: constantRoutes
});

setupGuard(router);

export { router };
